import styles from "./ResizableDiv.module.scss";
import { forwardRef, ReactNode, useEffect, useRef, useState } from "react";
import classNames from "classnames";

type ResizableDivProps = {
  children?: ReactNode;
  className?: string;
  isResizeEnabled?: boolean;
  minHeight: number;
};

export const ResizableDiv = forwardRef<HTMLDivElement, ResizableDivProps>(
  ({ children, className, isResizeEnabled, minHeight }, ref) => {
    const [height, setHeight] = useState(minHeight);
    useEffect(() => {
      setHeight(minHeight);
    }, [minHeight]);
    const [isResizing, setIsResizing] = useState(false);
    const startY = useRef(0);
    const startHeight = useRef(0);

    const setBodyStyleAttributes = (
      cursor: string,
      userSelect: string,
      pointerEvents: string,
    ) => {
      document.body.style.cursor = cursor;
      document.body.style.userSelect = userSelect;
      document.body.style.pointerEvents = pointerEvents;
    };

    const handleMouseMove = (e: MouseEvent) => {
      const newHeight = startHeight.current + (e.clientY - startY.current);
      setHeight(Math.max(newHeight, minHeight));
    };

    const handleMouseUp = () => {
      setIsResizing(false);

      setBodyStyleAttributes("", "", "");

      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    const handleMouseDown = (e: React.MouseEvent) => {
      setIsResizing(true);

      startY.current = e.clientY;
      startHeight.current = height;
      setBodyStyleAttributes("ns-resize", "none", "none");

      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    };

    return (
      <div className={styles.ResizableDiv}>
        <div
          ref={ref}
          className={classNames(styles.container, className)}
          style={{
            height,
          }}
        >
          {children}
        </div>
        {isResizeEnabled && (
          <div className={styles.resizer} onMouseDown={handleMouseDown} />
        )}
        {isResizing && <div className={styles.overlay} />}
      </div>
    );
  },
);
